<template>
  <div class="Our-main">
    <div class="FAQ-nav">
      <span class="bar"></span>
      <h2>Bizning manzillar</h2>
    </div>
    <div class="Our-Destination-wrapper">
      <div class="Our-map">
        <Leaflet />
      </div>
      <div class="Our-destination-form">
        <Free_Consultation />
      </div>
    </div>
    <div class="Our-destination-footer">
      <h2>{{ $t("footer__address") }}</h2>
      <p>
        <span>{{ $t("footer__work_time_label") }}</span
        >{{ $t("footer__work_time_value") }}
      </p>
      <p>
        <span>{{ $t("footer__contact_label") }}</span
        >{{ $t("footer__contact_value") }}
      </p>
    </div>
  </div>
</template>

<script>
import Free_Consultation from "../Free_consultation/Free_Consultation.vue";
import Leaflet from "@/components/Maps/MapComponent.vue";
export default {
  components: {
    Free_Consultation,
    Leaflet,
  },
};
</script>

<style>
.Our-main {
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.Our-Destination-wrapper {
  width: 100%;
  height: auto;
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 22px;
}
.Our-map {
  width: 770px;
  height: 100%;
  color: white;
  border-radius: 15px;
  overflow: hidden;
}
.Our-destination-form {
  width: 458px;
  height: auto;
  margin-top: 10px;
}
.Our-destination-footer {
  width: 100%;
  
  background-color: rgba(13, 13, 13, 1);
  border-radius: 15px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 10px 33px;
}
.Our-destination-footer h2 {
  font-size: 16px;
  font-weight: 500;
  line-height: 120%;
  width: 40%;
  color: rgba(255, 255, 255, 1);
}
.Our-destination-footer span {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.5);
  margin-right: 10px;
  font-family: Manrope;
}
.Our-destination-footer p {
  font-size: 20px;
  color: rgba(255, 255, 255, 1);
  font-family: Manrope;
}
@media (max-width: 1200px) {
  .Our-map {
    width: 100%;
    height: 380px;
  }
}
@media (max-width: 768px) {
  .Our-destination-footer {
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    margin-bottom: 30px;
  }
  .Our-map {
    width: 100%;
    height: 300px;
  }
  .Our-destination-form {
    margin-top: 30px;
    height: auto;
  }
  .Our-destination-footer h2 {
    width: 100%;
  }
}
@media (max-width: 420px) {
  .Our-map {
    width: 100%;
    height: 250px;
  }
}
</style>
